module.exports = __webpack_public_path__ + "img/header_bg_tc.dddd21d1.png";